module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-x-e21725a2cf3030af82fa428858051660.svg";